<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('resourceStoreType.queryCondition') }}</div>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="resourceStoreTypeManageInfo.conditions.name"
              :placeholder="$t('resourceStoreType.typeNamePlaceholder')"
              clearable
            />
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="_queryResourceStoreTypeMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('resourceStoreType.goodsType') }}</div>
          <el-button type="primary" size="small" @click="_openAddResourceStoreTypeModal">
            <i class="el-icon-plus"></i> {{ $t('common.add') }}
          </el-button>
      </div>
      <div class="">
        <el-table
          :data="resourceStoreTypeManageInfo.resourceStoreTypes"
          border
          style="width: 100%"
        >
          <el-table-column prop="rstId" :label="$t('resourceStoreType.typeId')" align="center" />
          <el-table-column prop="name" :label="$t('resourceStoreType.typeName')" align="center" />
          <el-table-column prop="description" :label="$t('resourceStoreType.typeDesc')" align="center" />
          <el-table-column prop="createTime" :label="$t('resourceStoreType.createTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="_openEditResourceStoreTypeModel(scope.row)"
              >
                {{ $t('common.edit') }}
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="_openDeleteResourceStoreTypeModel(scope.row)"
              >
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="resourceStoreTypeManageInfo.total"
        />
      </div>
    </el-card>

    <add-resource-store-type ref="addResourceStoreType" @refresh="_queryResourceStoreTypeMethod" />
    <delete-resource-store-type ref="deleteResourceStoreType" @refresh="_queryResourceStoreTypeMethod" />
    <edit-resource-store-type ref="editResourceStoreType" @refresh="_queryResourceStoreTypeMethod" />
  </div>
</template>

<script>
import { listResourceStoreTypes } from '@/api/housekeeping/resourceStoreTypeApi'
import AddResourceStoreType from '@/components/goods/addResourceStoreType/addResourceStoreType'
import DeleteResourceStoreType from '@/components/goods/deleteResourceStoreType/deleteResourceStoreType'
import EditResourceStoreType from '@/components/goods/editResourceStoreType/editResourceStoreType'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ResourceStoreTypeManage',
  components: {
    AddResourceStoreType,
    DeleteResourceStoreType,
    EditResourceStoreType
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      resourceStoreTypeManageInfo: {
        resourceStoreTypes: [],
        total: 0,
        records: 1,
        conditions: {
          rstId: '',
          name: '',
          description: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this._listResourceStoreTypes(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listResourceStoreTypes(this.currentPage, this.pageSize)
    },
    async _listResourceStoreTypes(page, rows) {
      this.resourceStoreTypeManageInfo.conditions.page = page
      this.resourceStoreTypeManageInfo.conditions.row = rows
      this.resourceStoreTypeManageInfo.conditions.shopId = getShopId()

      try {
        const res = await listResourceStoreTypes(this.resourceStoreTypeManageInfo.conditions)
        this.resourceStoreTypeManageInfo.total = res.total
        this.resourceStoreTypeManageInfo.records = res.records
        this.resourceStoreTypeManageInfo.resourceStoreTypes = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryResourceStoreTypeMethod() {
      this.currentPage = 1
      this._listResourceStoreTypes(this.currentPage, this.pageSize)
    },
    _openAddResourceStoreTypeModal() {
      this.$refs.addResourceStoreType.open()
    },
    _openDeleteResourceStoreTypeModel(row) {
      this.$refs.deleteResourceStoreType.open(row)
    },
    _openEditResourceStoreTypeModel(row) {
      this.$refs.editResourceStoreType.open(row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
</style>